/**
 * A workspace's open (PENDING) governance exceptions as text. A real count —
 * including a real 0 — prints as a number; null / undefined means the count was
 * not read or could not be read, and prints "Unavailable", never "0".
 */
export function formatOpenExceptions(value: number | null | undefined): string {
  return formatCountOrUnavailable(value);
}

/** Any count: a number (including a real 0) prints; null / undefined → "Unavailable". */
export function formatCountOrUnavailable(value: number | null | undefined): string {
  return typeof value === "number" ? String(value) : "Unavailable";
}
